import { useEffect, useState } from 'react'
import { cn } from '../lib/utils'

function avatarInitial(name?: string | null, email?: string | null): string {
  return (name?.trim() || email?.trim() || 'U').charAt(0).toUpperCase()
}

interface UserAvatarProps {
  src?: string | null
  name?: string | null
  email?: string | null
  alt?: string
  className?: string
  imageClassName?: string
  fallbackClassName?: string
}

/** Canonical profile-avatar renderer with an initials fallback for failed images. */
export function UserAvatar({
  src,
  name,
  email,
  alt = '',
  className,
  imageClassName,
  fallbackClassName,
}: UserAvatarProps) {
  const [broken, setBroken] = useState(false)

  useEffect(() => {
    setBroken(false)
  }, [src])

  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center justify-center overflow-hidden rounded-full bg-secondary',
        className,
      )}
    >
      {src && !broken ? (
        <img
          src={src}
          alt={alt}
          className={cn('h-full w-full object-cover', imageClassName)}
          onError={() => setBroken(true)}
        />
      ) : (
        <span
          aria-hidden={alt ? undefined : true}
          role={alt ? 'img' : undefined}
          aria-label={alt || undefined}
          className={cn('font-semibold text-foreground', fallbackClassName)}
        >
          {avatarInitial(name, email)}
        </span>
      )}
    </span>
  )
}
